import { combineReducers } from 'redux';

import authReducer from 'store/modules/auth';
import contentReducer from 'store/modules/content';
import linksReducer from 'store/modules/links';
import stylesReducer from 'store/modules/styles';
import profileDetails from 'store/modules/profileDetails';
import analitics from 'store/modules/analitics';
import modals from 'store/modules/modals';
import feedback from 'store/modules/feedback';
import langs from 'store/modules/langs';

export default combineReducers({
  auth: authReducer,
  content: contentReducer,
  links: linksReducer,
  styles: stylesReducer,
  details: profileDetails,
  full_stat: analitics,
  modals: modals,
  feedback: feedback,
  langs: langs,
});



// WEBPACK FOOTER //
// ./src/store/root-reducer.js